import moment from "moment-jalaali"
import { PickerValue } from "react-mobile-picker"

moment.locale("fa")

export const monthsList = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند"
]

export function getYearsRange(currentYear: number) {
  return Array.from({ length: 100 }, (_, i) => `${currentYear - 99 + i}`)
}

export function getMonthsRange(currentDate: moment.Moment, selectedDate: PickerValue) {
  const currentYear = currentDate.jYear()
  const currentMonth = currentDate.jMonth()
  const selectedYear = selectedDate.year
  // @ts-ignore
  const currentYearIsSelected = selectedYear == currentYear
  if (currentYearIsSelected) {
    return Array.from({ length: currentMonth + 1 }, (_, i) => String(i + 1).padStart(2, "0"))
  }
  return Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"))
}

export function getDatesRange(currentDate: moment.Moment, selectedDate: PickerValue) {
  const currentYear = currentDate.jYear()
  const currentMonth = currentDate.jMonth()
  const selectedYear = selectedDate.year
  const selectedMonth = selectedDate.month
  // @ts-ignore
  const currentYearIsSelected = selectedYear == currentYear
  // @ts-ignore
  const currentMonthIsSelected = selectedMonth == currentMonth + 1
  if (currentYearIsSelected && currentMonthIsSelected) {
    return Array.from({ length: currentDate.jDate() }, (_, i) => String(i + 1).padStart(2, "0"))
  }
  const daysInMonth = moment.jDaysInMonth(+selectedDate.year, +selectedDate.month - 1)
  return Array.from({ length: daysInMonth }, (_, i) => String(i + 1).padStart(2, "0"))
}

export function getFormattedDate(data: string, options?: object) {
  if (!data) return ""
  return new Date(data).toLocaleDateString("fa-IR", options)
}

export function formatRelativeDate(date: string | Date): string {
  const targetDate = moment(date)
  return targetDate.fromNow()
}

export function getDaysUntil(currentDate: string | Date, eventDate: string | Date, ignoreYear?: boolean): number {
  const today = moment(currentDate).startOf("day")

  let targetDate: moment.Moment

  if (ignoreYear) {
    const event = moment(eventDate)
    const jm = event.jMonth() + 1 // jMonth is 0-based
    const jd = event.jDate()
    const jy = today.jYear()

    targetDate = moment(`${jy}/${jm}/${jd}`, "jYYYY/jM/jD")
  } else {
    targetDate = moment(eventDate)
  }

  if (ignoreYear && targetDate.isBefore(today)) {
    targetDate.add(1, "year")
  }

  return targetDate.diff(today, "days")
}
